import moment from 'moment';
import React, { useEffect, useMemo } from 'react'
import useStateRef from 'react-usestateref';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import { Button } from 'react-bootstrap';
import Helper from '../Helper';

const LivingCalendarModalV1 = (props) => {
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    const [selectedAlternateDate, setSelectedAlternateDate, selectedAlternateDateRef] = useStateRef();
    const [showDate, setShowDate, showDateRef] = useStateRef();
    const [selectDate, setSelectDate, selectDateRef] = useStateRef();
    const [displayDateLiving, setDisplayDateLiving, displayDateLivingRef] = useStateRef()
    const [oneSpecial, setOneSpecial, oneSpecialRef] = useStateRef();
    const formattedDateCurrent = moment(showDateRef.current).format('YYYY-MM-DD HH:mm:ss.SSS');
    const [livingShipMethod, setLivingShipMethod, livingShipMethodRef] = useStateRef();
    const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    const validShowDate = (showDateRef.current instanceof Date && !isNaN(showDateRef.current)) ? showDateRef.current : new Date();
    const validSelectedDate = (selectDateRef.current instanceof Date && !isNaN(selectDateRef.current)) ? selectDateRef.current : null;

    const firstDayThisMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth(), 1);
    const dayOfWeek = firstDayThisMonth.getDay();
    const firstDayNextMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1);
    const lastDayThisMonth = new Date(firstDayNextMonth - 1);
    const lastDayOfWeek = lastDayThisMonth.getDay();
    const currentMoment = moment();
    const isCurrentMonth = validShowDate.getFullYear() === currentMoment.year() && validShowDate.getMonth() === currentMoment.month();
    const [livingShipMethodPrev, setLivingShipMethodPrev, livingShipMethodPrevRef] = useStateRef(props?.currentData?.oneSpecial?.shippingMethod);
    // For living item alternateDates1 & alternateDates2 are enable, For livingSpecial item alternateDates1 only enable & specialAlternateDates2 are disable
    let alternateDates1;
    let alternateDates2;
    function handleShipMethod(method) {
        console.log("handleShipMethod fired",method);
        if(method != livingShipMethodRef.current && selectedAlternateDateRef?.current == true){
            console.log("handleShipMethod livingShipMethodRef.current",livingShipMethodRef.current);
        setLivingShipMethodPrev(livingShipMethodRef.current)
        console.log("handleShipMethod livingShipMethodRef.current",livingShipMethodPrevRef.current);
        setLivingShipMethod(method)
        console.log("handleShipMethod livingShipMethodRef.current",livingShipMethodRef.current);
        }
    }
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;

    }
    const month = useMemo(() => {
        const days = [];
        for (let d = firstDayThisMonth; d < firstDayNextMonth; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d));
        }
        return days;
    }, [validShowDate]);

    const parseDates = (dateString) => {
        if (!dateString) return [];
        return dateString.split(' ').map(date => {
            const parsedDate = moment(date, 'MM/DD/YYYY', true);
            return parsedDate.isValid() ? parsedDate.toDate() : null;
        }).filter(date => date !== null);
    };
    const isDateInList = (date, list) => {
        if (list) {
            return list.some(d => d.getTime() === date.getTime());
        }
    };

    const isDateInAlternateDate = (date, list) => {
        if (list) {
            console.log("isDateInAlternateDate date",date);
            console.log("isDateInAlternateDate list",list);
            let unavailableMethodDates = list?.split(' ').map(dates => dates.trim());
            console.log("isDateInAlternateDate unavailableMethodDates",unavailableMethodDates);
            let isUnavailableMethodDate = unavailableMethodDates.includes(date);
            console.log("isDateInAlternateDate isUnavailableMethodDate",isUnavailableMethodDate);
           return isUnavailableMethodDate;
        }
    };
    useEffect(() => {
        setSelectedAlternateDate(props.currentData?.oneSpecial?.deliveryDate || props.currentData?.currentDate ? true : false);
        setShowDate(new Date(moment(props.currentData?.oneSpecial?.deliveryDate ?? props.currentData?.currentDate)));
        setSelectDate(new Date(moment(props.currentData?.oneSpecial?.deliveryDate ?? props.currentData?.currentDate)));
        setDisplayDateLiving(props?.currentData ? ` ${moment(props.currentData?.oneSpecial?.deliveryDate ?? props.currentData?.currentDate).format('MMMM DD, YYYY')}` : 'Select a date');
        setOneSpecial(props?.currentData?.oneSpecial);
        alternateDates1 = parseDates(props?.currentData?.dates?.alternateDates1 ?? '');
        alternateDates2 = parseDates(props?.currentData?.dates?.alternateDates2 ?? '');
        setLivingShipMethod(props?.currentData?.oneSpecial?.shippingMethod ?? props?.currentData?.shipType ?? "")
        setLivingShipMethodPrev(props?.currentData?.oneSpecial?.shippingMethod ?? props?.currentData?.shipType ?? "")
        console.log(" useeffect selectDateRef.current",selectDateRef.current);
        const validSelectedDate = (selectDateRef.current instanceof Date && !isNaN(selectDateRef.current)) ? selectDateRef.current : null;
        console.log(" useeffect validSelectedDate",validSelectedDate);
        console.log(" useeffect alternateDates1",alternateDates1);
        const formattedDate = moment(validSelectedDate).format('MM/DD/YYYY');
        let isAlternateDate = isDateInAlternateDate(formattedDate, props?.currentData?.dates?.alternateDates1);
        console.log(" useeffect isAlternateDate",isAlternateDate);
        if (isAlternateDate) {
            setSelectedAlternateDate(false);
            setLivingShipMethodPrev("Second Day Air")
            setLivingShipMethod('Overnight')
        }
        
    }, [props.currentData])




    alternateDates1 = parseDates(props?.currentData?.dates?.alternateDates1 ?? '');
    alternateDates2 = parseDates(props?.currentData?.dates?.alternateDates2 ?? '');




    const onChange = (date) => {
        console.log("onChange fired");
        // setShowDate(date)
        setSelectDate(date)
        const formattedDate = moment(date).format('MM/DD/YYYY');
        const unavailableMethodDates = props?.currentData?.dates?.alternateDates1?.split(' ').map(date => date.trim());
        const isUnavailableMethodDate = unavailableMethodDates.includes(formattedDate);
        if (!isUnavailableMethodDate) {
            setSelectedAlternateDate(true);
        } else {
            setSelectedAlternateDate(false);
            if (livingShipMethodRef.current == 'Second Day Air') {
                setLivingShipMethodPrev(livingShipMethodRef.current)
                setLivingShipMethod('Overnight')
            } else {
                setLivingShipMethod(livingShipMethodRef.current)
            }
        }
        setDisplayDateLiving(moment(date).format('MMMM DD, YYYY'));
    };





    async function handleLivingCalendar(event) {
        event.preventDefault();
        setDisabled(true)
        // list map call
        if (props.currentData.group == true) {

            var actionUrl = "api/rest/cb/checkout/living-calendar";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                modifiedShippingMethod: livingShipMethodRef.current,
                groupName: 'KEY_LIVING_MATERIAL',
                currentDate: formattedDateCurrent,
                currentShipMethod: livingShipMethodPrevRef.current,
                selectedDate: moment(displayDateLivingRef.current).format('MM/DD/YYYY')

            }))
            if (res.result == "success") {
                var livingModalClose = document.getElementById(`save-living-calendar-success`)
                setDisabled(false)
                livingModalClose.click();
                props.handleOrderDetails()
                
            }
            else {
                setDisabled(false)
                console.log("errorList-----", res)
            }

        } else {
            var actionUrl = "api/rest/cb/checkout/living-calendar-without-groupname";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                selectedShippingMethod: livingShipMethodRef.current,
                currentDate: formattedDateCurrent,
                currentShipMethod: livingShipMethodPrevRef.current,
                selectedDate: moment(displayDateLivingRef.current).format('MM/DD/YYYY'),
                currentcommerceItemId: props.currentData?.oneSpecial?.commerceItemId ?? '',
                currentSkuId: props.currentData?.oneSpecial?.itemNumber ?? '',
                currentquantity: props.currentData?.oneSpecial?.quantity ? String(props.currentData?.oneSpecial?.quantity) : "0",
                selectedShipGroupId: props.currentData?.oneSpecial?.shippingGroupId ?? '',
                backOrdered: ""

            }))
            if (res.result == "success") {
                var livingModalClose = document.getElementById(`save-living-calendar-success`)
                setDisabled(false)
                livingModalClose.click();
                props.handleOrderDetails()
            }
            else {
                setDisabled(false)
                console.log("errorList-----", res)
            }
        }
    };


    return (
        <div> <div className="modal gx-0 fade c-shopping-list-modal-body" id={`livingCalendar`} tabindex="-1" aria-labelledby={`livingCalendar`} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                <div className="modal-content">
                    <button type="button" className="btn-close" id={`save-living-calendar-success`} data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="modal-body">
                        <div className="c-checkout-calendar" id="calendar">
                            <div className='col-md-12'>
                                <div className="form-group row p-md-5 ">
                                    <div className="col-md-7">
                                        <div className="mr-auto title font-weight-bold">

                                            <h1 className="c-account-heading mb-3">
                                                Change Arrival Date for item
                                            </h1>
                                            {/* <h1 className="c-account-heading mb-3">
                                                Change Arrival Date<br />for all perishable items
                                            </h1> */}

                                        </div>

                                        {oneSpecialRef.current ?
                                            <div className="c-delivery-item">
                                                <span className="c-delivery-img">
                                                    <img onError={replaceImage} src={oneSpecialRef?.current?.imagePath} /></span>
                                                <div className="c-delivery-items">
                                                    <p className="c-delivery-item-text">#{oneSpecialRef?.current?.itemNumber} Qty:{oneSpecialRef?.current?.quantity}</p>
                                                    <p className="c-delivery-item-text">{oneSpecialRef?.current?.productDescription}</p>
                                                </div>
                                            </div> : ""}

                                        <div className="" dangerouslySetInnerHTML={{
                                            __html: props?.currentData.message
                                        }}>
                                        </div>
                                        <form className="mt-4 ml-1">
                                            <h1 className="c-account-heading mb-4">Select shipping method:<p></p>
                                                <div className="row g-4 c-shipping-box-small">
                                                    <label className="col-12 col-md-6" htmlFor='livingCalenterDayAir' onClick={() => { handleShipMethod("Second Day Air") }}>
                                                        <div className={`c-box-shipping ${selectedAlternateDateRef?.current == true && livingShipMethodRef?.current === "Second Day Air" && 'active'}`}>
                                                            {selectedAlternateDateRef?.current == true ?
                                                                <div className="form-check"> <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="livingCalendarModal"
                                                                    id="livingCalenterDayAir"
                                                                    value="2 Day Air"
                                                                    checked={livingShipMethodRef?.current === "Second Day Air"}
                                                                    defaultChecked={livingShipMethodRef?.current === "Second Day Air"}
                                                                    onChange={() => { handleShipMethod("Second Day Air") }}
                                                                /> </div> : ""}

                                                            <div className="c-box-shipping-calendar">
                                                                <div className="c-box-calendar-info">
                                                                    <p>2 Day Air</p>
                                                                    {selectedAlternateDateRef?.current == false ? <p>(unavailable)</p> : ""}
                                                                </div>
                                                                <div className="container-circle">
                                                                    <div className="circle-tick"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>

                                                    <label className="col-12 col-md-6" htmlFor='livingCalendarOvernight' onClick={() => { handleShipMethod("Overnight") }}>
                                                        <div className={`c-box-shipping ${livingShipMethodRef?.current === "Overnight" && 'active'} `}>
                                                            <div className="form-check"> <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="livingCalendarModal"
                                                                id="livingCalendarOvernight"
                                                                value="Overnight"
                                                                checked={livingShipMethodRef?.current === "Overnight"}
                                                                defaultChecked={livingShipMethodRef?.current === "Overnight"}
                                                                onChange={() => { handleShipMethod("Overnight") }}
                                                            />
                                                            </div>
                                                            <div className="c-box-shipping-calendar">
                                                                <div className="c-box-calendar-info">
                                                                    <p>Overnight</p>
                                                                </div>
                                                                <div className="container-circle">
                                                                    <div className="circle-tick"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </h1>
                                        </form>
                                    </div>
                                    <div className="col-12 col-md-5 cb-calendar-modal">
                                        <div className="calendar">
                                            <div className="d-flex justify-content-between cb-month-row">
                                                <Button className='cb-month-previous'
                                                    onClick={() => setShowDate(new Date(validShowDate.getFullYear(), validShowDate.getMonth() - 1, 1))}
                                                    disabled={isCurrentMonth}>
                                                    <span>&lt;</span>
                                                </Button>
                                                <div className='cb-month-cell'>
                                                    {validShowDate.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
                                                </div>
                                                <Button className='cb-month-next' onClick={() => setShowDate(new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1))} >
                                                    <span>&gt;</span>
                                                </Button>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                {weekDays.map((weekDay, index) => (
                                                    <div key={index} className="day cb-weekday">
                                                        <small>{weekDay}</small>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="d-flex flex-wrap list-days">
                                                {Array.from({ length: dayOfWeek }).map((_, index) => (
                                                    <div key={index} className="day cell_day empty_cell_start" style={{ flex: '0 0 14.28%' }}></div>
                                                ))}
                                                {month.map((day) => {
                                                    const isAlternateDate1 = isDateInList(day, alternateDates1);
                                                    const isAlternateDate2 = isDateInList(day, alternateDates2);
                                                   
                                                    const highlightSelectedDate =
                                                        validSelectedDate &&
                                                        validSelectedDate.getDate() === day.getDate() &&
                                                        validSelectedDate.getMonth() === day.getMonth() &&
                                                        validSelectedDate.getFullYear() === day.getFullYear();
                                                    
                                                    
                                                    const variant = isAlternateDate1 ? 'onchange-dates' : isAlternateDate2 ? 'onchange-dates' : 'disabled-dates';
                                                    const disabled = !isAlternateDate1 && !isAlternateDate2;

                                                    return (
                                                        <div key={day} className="day cell_day cell_of_days">
                                                            <Button
                                                                variant={highlightSelectedDate ? 'highlight-selected-date' : variant}
                                                                onClick={() => onChange(day)}
                                                                className="w-100"
                                                                disabled={disabled}
                                                            >
                                                                {day.getDate()}
                                                            </Button>
                                                        </div>
                                                    );
                                                })}
                                                {Array.from({ length: 6 - lastDayOfWeek }).map((_, index) => (
                                                    <div key={index} className="day cell_day empty_cell_end" style={{ flex: '0 0 14.28%' }}></div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="mt-5 m-auto text-center fst-italic" style={{ width: '280px' }}>
                                            <span>Selected Date:</span>
                                            <span id="dateDisplay">{displayDateLivingRef.current}</span>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-4 text-center  mt-5 mb-md-5 d-grid m-md-auto">
                                    <button id="saveDateLiving" disabled={disabledRef.current == true ? true:""} onClick={(event) => handleLivingCalendar(event)} className="btn btn-primary block" >SAVE DATE</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div></div>
    )
}

export default LivingCalendarModalV1